import React from 'react'
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'
import PapersTable from '../../../components/molecules/PapersTable'
import RouterMetaTags from '../../../components/molecules/RouterMetaTags'
import { Routes } from '../../../consts'
import { useLogin } from '../../organisms/Login'
import { usePaper } from '../../organisms/Paper'
import DeleteDialog from './DeleteDialog'

const Component = () => {
  const { papers } = usePaper()
  const { fbUser } = useLogin()
  if (!fbUser) {
    return <></>
  }

  const myPapers = papers.filter(p => p.uid === fbUser.uid)

  return (
    <>
      <RouterMetaTags route={Routes.Account} />
      <Typography variant="h2">Review/edit the tag info on the papers you added</Typography>
      <Typography variant="body2" color="primary" gutterBottom>
        Select a paper to edit.
      </Typography>

      <PapersTable papers={myPapers} />
      <Divider style={{ margin: '50px 0' }} />
      <DeleteDialog />
    </>
  )
}

export default Component
